<template>
  <div class="warp">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <!-- <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加工作分类')">添加</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteGroup">批量删除</el-button> -->
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
    </div>
    <!-- 筛选 -->
    <el-form ref="screenForm" :inline="true" :model="screenForm" class="demo-form-inline">
      <el-form-item label="用户手机号：" prop="memberPhone">
        <el-input v-model="screenForm.memberPhone" />
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData">筛选</el-button>
    </el-form>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        style="width: max-content"
        :data="tableData"
        :stripe="true"
        :border="true"
        size="mini"
        tooltip-effect="dark"
      >
        <el-table-column type="index" width="50" label="#" />
        <el-table-column prop="memberPhone" label="用户" width="100" />
        <el-table-column prop="content" label="反馈内容" width="200" />
        <el-table-column label="相关图片" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.images" style="width: 100%; min-height: 50px; display: flex; justify-content: center; margin-top: 6px">
              <div v-for="(url, index) in scope.row.images" :key="index" style="margin-bottom: 6rpx; margin-right: 6px">
                <el-image :src="url" style="width: 50px; height: 50px; border-radius: 6px" @click="previewImage(url)" />
              </div>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" width="150" />
        <el-table-column prop="createDate" label="创建时间" width="160" />
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/mixins/pagination'
export default {
  mixins: [pagination],
  data() {
    return {
      tableData: [],
      screenForm: { memberPhone: '' },
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      loading: true,
      tableH: 0
    }
  },

  created() {
    this.getTableList()
  },
  mounted() {
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    getTableList() {
      this.loading = true
      return this.$api.member
        .reqFeedbackList(this.page)
        .then((res) => {
          this.tableData = res.records
          this.total = res.total
          const ids = res.records.map((item) => item.memberId).join(',')
          this.getMemberByIds({ ids })
        })
        .catch(() => {})
    },
    getMemberByIds(data) {
      return this.$api.member
        .reqMemberByIds(data)
        .then((res) => {
          console.log('res', res)
          this.tableData.forEach((item) => {
            this.$set(item, 'memberPhone', res[item.memberId] && res[item.memberId].phone)
          })
          this.loading = false
        })
        .catch(() => {})
    },
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.$refs.screenForm.resetFields()
      Promise.all([this.getTableList()])
        .then((res) => {
          this.$message.success('刷新成功')
        })
        .catch(() => {
          this.$message.error('刷新成功')
        })
    },
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.screenForm)
      this.getTableList()
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
